import {
  getUserEmailFromCookies,
  getUserFirstNameFromCookies,
  getUserLastNameFromCookies,
  getPhoneNumberFromCookies,
  getCityFromCookies,
  getStateFromCookies,
} from './getUserDetailsUtil'
import { KLAVIYO_PUBLIC_API_KEY } from '../../../constants/index'
import { headers } from './headers'

export const updateKlaviyoProfile = () => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'profile',
        attributes: {
          email: getUserEmailFromCookies() ?? '',
          properties: { //custom properties
            $first_name: getUserFirstNameFromCookies(),
            $last_name: getUserLastNameFromCookies(),
            $phone_number: getPhoneNumberFromCookies(),
            $city: getCityFromCookies(),
            $region: getStateFromCookies(),
          },
        }
      }
    })
  }

  fetch(`https://a.klaviyo.com/client/profiles/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo upadting profile success', response)
  })
  .catch(err => console.log('Filed to update klaviyo profile', err))
}

export const trackUserLogIn = async (email) => {
  const options = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          properties: {$email: email},
          metric: {data: {type: 'metric', attributes: {name: 'User Logged In'}}},
          profile: {
            data: {
              type: 'profile',
              attributes: {
                properties: {$email: email}, //An object containing key/value pairs for any custom properties assigned to this profile
                email: email
              }
            }
          }
        }
      }
    })
  }

  await fetch(`https://a.klaviyo.com/client/events/?company_id=${KLAVIYO_PUBLIC_API_KEY}`, options)
  .then(response => {
    console.log('klaviyo tracking login success', response)
    updateKlaviyoProfile()
  })
  .catch(err => {
    console.log('Failed to track klaviyo login', err)
  })
}
